import React, { useState, useMemo, useEffect } from 'react';
import GoogleMapReact from 'google-map-react';
import { greatPlaceStyle } from './my_great_place_styles.js';
import img from '../../../../public/assets/img/test-front.png';

const Mape = ({ latitude, longitude, infoTotal, clck, zoom }) => {
  const [zoomzzom, setZoomzzom] = useState(1);

  let zm = zoom;
  let infoTotalinMap = infoTotal;

  const renderMarkers = (map, maps) => {
    let marker = new maps.Marker({
      map,
      title: 'Hello World!',
    });
    return marker;
  };

  function handleClick(text, empresa, email, direccion) {
    clck(text, empresa, email, direccion);
  }

  function funcZooom(asd) {
    return asd;
  }

  const MyGreatPlace = ({ text, empresa, email, direccion }) => (
    <button onClick={() => handleClick(text, empresa, email, direccion)}>
      <div style={greatPlaceStyle}>{text}</div>
    </button>
  );

  useEffect(() => {
    setZoomzzom(zoom);
    funcZooom(zoom);
  }, [zoom, zoomzzom]);

  return (
    <div className="mapaResponsive md:h-full md:w-full ">
      {zoomzzom == 4 ? (
        <GoogleMapReact
          bootstrapURLKeys={{
            key: 'AIzaSyCOddxQpUZx8GJ6JUjGVEhrqox9mfP7bxM',
            language: 'es',
            region: 'es',
            libraries: ['places'],
          }}
          center={{ lat: latitude, lng: longitude }}
          zoom={zoomzzom}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
        >
          {infoTotalinMap.map((x) => (
            <MyGreatPlace
              key={x.name}
              lat={x.latitud}
              lng={x.longitud}
              //  text={'A'}
              empresa={x.nombre}
              email={x.email}
              direccion={x.direccion}
              icon={
                'https://lh3.googleusercontent.com/bECXZ2YW3j0yIEBVo92ECVqlnlbX9ldYNGrCe0Kr4VGPq-vJ9Xncwvl16uvosukVXPfV=w300'
              }
              /* Kreyser Avrora */
            />
          ))}
        </GoogleMapReact>
      ) : zoomzzom == 7 ? (
        <GoogleMapReact
          bootstrapURLKeys={{
            key: 'AIzaSyCOddxQpUZx8GJ6JUjGVEhrqox9mfP7bxM',
            language: 'es',
            region: 'es',
            libraries: ['places'],
          }}
          center={{ lat: latitude, lng: longitude }}
          zoom={zoomzzom}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
        >
          {infoTotalinMap.map((x) => (
            <MyGreatPlace
              key={x.name}
              lat={x.latitud}
              lng={x.longitud}
              //  text={'A'}
              empresa={x.nombre}
              email={x.email}
              direccion={x.direccion}
              icon={
                'https://lh3.googleusercontent.com/bECXZ2YW3j0yIEBVo92ECVqlnlbX9ldYNGrCe0Kr4VGPq-vJ9Xncwvl16uvosukVXPfV=w300'
              }
              /* Kreyser Avrora */
            />
          ))}
        </GoogleMapReact>
      ) : zoomzzom == 10 ? (
        <GoogleMapReact
          bootstrapURLKeys={{
            key: 'AIzaSyCOddxQpUZx8GJ6JUjGVEhrqox9mfP7bxM',
            language: 'es',
            region: 'es',
            libraries: ['places'],
          }}
          center={{ lat: latitude, lng: longitude }}
          zoom={10}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
        >
          {infoTotalinMap.map((x) => (
            <MyGreatPlace
              key={x.name}
              lat={x.latitud}
              lng={x.longitud}
              //  text={'A'}
              empresa={x.nombre}
              email={x.email}
              direccion={x.direccion}
              // icon={"https://lh3.googleusercontent.com/bECXZ2YW3j0yIEBVo92ECVqlnlbX9ldYNGrCe0Kr4VGPq-vJ9Xncwvl16uvosukVXPfV=w300"}
              /* Kreyser Avrora */
            />
          ))}
        </GoogleMapReact>
      ) : (
        <div
          style={{
            display: 'flex',
            width: '100%',
            height: '100%',
          }}
        >
          <div
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%',
              border: ' 1px solid #414141',
              borderRadius: '1rem',
              backgroundImage: `url(${img})`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default Mape;
